<div class="edi-import-container">
  <div class="card border edi-import-card">
    <div class="edi-import-header px-4 py-3 border-bottom">
      <div class="d-flex align-items-start justify-content-between flex-wrap">
        <div class="d-flex align-items-start">
          <div class="import-icon mr-3">
            <i class="fa fa-upload" aria-hidden="true"></i>
          </div>
          <div>
            <h3 class="mb-1">{{ 'UPLOAD_EDI_ORDER_XML' | translate | uppercase }}</h3>
            <p class="text-muted mb-0">Upload and process a file using a selected EDI configuration.</p>
          </div>
        </div>
        <div class="edi-config-stats mt-2 mt-md-0">
          <span class="badge badge-success mr-2">Enabled: {{ enabledConfigurationsCount }}</span>
          <span class="badge badge-secondary">Not enabled: {{ disabledConfigurationsCount }}</span>
        </div>
      </div>
    </div>

    <div class="card-body p-4">
      <div *ngIf="selectedConfigWarning" class="alert alert-warning py-2 mb-3" role="alert">
        <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
        {{ selectedConfigWarning }}
      </div>

      <div class="row">
        <div class="col-12 col-lg-7 mb-3 mb-lg-0">
          <div class="step-card p-3 h-100">
            <div class="step-title mb-2">
              <span class="step-number mr-2">1</span>
              <span class="font-weight-bold">Choose Configuration</span>
            </div>
            <label for="edi-config-id" class="small text-muted mb-2">Target EDI Config ID</label>
            <select
              id="edi-config-id"
              class="form-control"
              [disabled]="loading || loadingConfigurations ? true : null"
              [value]="selectedConfigId"
              (change)="onConfigIdChange($event)"
            >
              <option value="" disabled>{{ loadingConfigurations ? 'Loading config IDs...' : 'Select config ID' }}</option>
              <option *ngFor="let configuration of configurations" [value]="configuration.id">{{ configuration.label }}</option>
            </select>
            <small *ngIf="!loadingConfigurations && !configurations.length" class="form-text text-danger">
              No EDI configurations found.
            </small>
            <div class="selected-config-state mt-2" *ngIf="selectedConfiguration">
              <span class="small text-muted mr-2">Status:</span>
              <span class="badge" [ngClass]="selectedConfiguration.enabled ? 'badge-success' : 'badge-warning'">
                {{ selectedConfiguration.enabled ? 'Enabled' : 'Not enabled' }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-5">
          <div class="step-card p-3 h-100">
            <div class="step-title mb-2">
              <span class="step-number mr-2">2</span>
              <span class="font-weight-bold">Select File</span>
            </div>
            <label for="file-upload" class="small text-muted mb-2 d-block" translate>SELECT_FILES</label>
            <div class="file-input-wrapper">
              <div class="small text-muted mb-2">Any file type is accepted.</div>
              <input
                #inputFile
                type="file"
                class="_custom-file-input w-100"
                id="file-upload"
                aria-describedby="file-upload"
                accept="*/*"
                [multiple]="false"
                [disabled]="loading || loadingConfigurations ? true : null"
              />
            </div>
            <small *ngIf="inputFile.files?.[0]" class="form-text text-muted selected-file-name mt-2">
              Selected file: <strong>{{ inputFile.files?.[0]?.name }}</strong>
            </small>
          </div>
        </div>
      </div>

      <div class="upload-summary d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-3 px-3 py-2">
        <div class="summary-item mb-2 mb-md-0">
          <span class="text-muted mr-2">Configuration:</span>
          <code>{{ selectedConfigId || 'Not selected' }}</code>
        </div>
        <div class="summary-item">
          <span class="text-muted mr-2">File:</span>
          <span>{{ inputFile.files?.[0]?.name || 'Not selected' }}</span>
        </div>
      </div>

      <div class="text-right mt-3">
        <button
          type="button"
          class="btn btn-primary px-5"
          (click)="uploadFile(inputFile)"
          [disabled]="loading || loadingConfigurations || !selectedConfigId || !inputFile.files?.length"
          translate
        >
          UPLOAD <i *ngIf="loading" class="fa fa-spinner fa-spin fa-lg ml-2"></i>
        </button>
      </div>
    </div>
  </div>
</div>
